<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaPartidos
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Partidos del Mundial

    v-layout(align-center='' justify-end='' row='' wrap='' style='margin-top:10px;margin-right:5px;gap:8px;')
      v-btn(style="background:#1a1a2e;border-radius:10px;" dark @click='abrirImportarJuegos')
        v-icon(left small) mdi-cloud-download
        | Importar desde API Mundial
      v-btn(style="background:#ff6500;border-radius:10px;" @click='abrirCrear') + Nuevo Partido

    v-layout(align-start='' justify-start='' row='' wrap='' style='margin-top:5px;')
      v-flex(xs12)
        v-data-table.elevation-1(:headers='headers' :items='resultados' :loading='loading')
          template(v-slot:items='props')
            td {{ props.item.fecha ? $moment(props.item.fecha).format('DD/MM/YYYY HH:mm') : '—' }}
            td {{ props.item.nombre_local }} vs {{ props.item.nombre_visitante }}
            td {{ faseName(props.item.fase) }}
            td {{ props.item.grupo || '—' }}
            td
              span(v-if="props.item.estado === 'finalizado'")
                | {{ props.item.resultado.goles_local }} - {{ props.item.resultado.goles_visitante }}
              span(v-else) —
            td
              v-chip(:color="estadoColor(props.item.estado)" dark small) {{ estadoLabel(props.item.estado) }}
            td
              v-btn(icon small @click='abrirEditar(props.item)')
                v-icon(color='#ff6500') edit
              v-btn(v-if="props.item.estado === 'pendiente'" icon small @click='abrirResultado(props.item)')
                v-icon(color='green') sports_score
              v-btn(icon small @click='eliminar(props.item._id)')
                v-icon(color='red') delete

  //- ─── MODAL CREAR/EDITAR ─────────────────────────────────────────────────────
  v-dialog(v-model='dialog' max-width='550px')
    v-card
      v-card-title(style='background:black;')
        span.white--text {{ editando ? 'Editar Partido' : 'Nuevo Partido' }}
      v-card-text(style='padding-top:20px;')
        v-layout(row wrap)
          v-flex(xs12 sm6 style='padding-right:8px;')
            v-select(outlined v-model='form.equipo_local' :items='equiposOpts' item-text='nombre' item-value='codigo' label='Equipo Local' dense @change='onLocalChange')
          v-flex(xs12 sm6)
            v-select(outlined v-model='form.equipo_visitante' :items='equiposOpts' item-text='nombre' item-value='codigo' label='Equipo Visitante' dense @change='onVisitanteChange')
          v-flex(xs12 sm6 style='padding-right:8px;')
            v-select(outlined v-model='form.fase' :items='faseOpts' label='Fase' dense)
          v-flex(xs12 sm6)
            v-text-field(outlined v-model='form.grupo' label='Grupo (si es fase grupos)' dense)
          v-flex(xs12)
            v-text-field(outlined v-model='form.fecha' label='Fecha y hora (YYYY-MM-DDTHH:mm)' dense placeholder='2026-06-11T15:00' type='datetime-local')
          v-flex(xs12 sm6 style='padding-right:8px;')
            v-text-field(outlined v-model.number='form.orden' label='Orden' type='number' dense)
      v-card-actions
        v-spacer
        v-btn(text @click='dialog = false') Cancelar
        v-btn(style='background:#ff6500;' dark @click='guardar' :loading='guardando') Guardar

  //- ─── MODAL RESULTADO ────────────────────────────────────────────────────────
  v-dialog(v-model='dialogRes' max-width='420px')
    v-card
      v-card-title(style='background:black;')
        span.white--text Registrar Resultado
      v-card-text(style='padding-top:20px;')
        p(style='font-weight:bold;text-align:center;') {{ partidoSeleccionado.nombre_local }} vs {{ partidoSeleccionado.nombre_visitante }}
        v-layout(row wrap)
          v-flex(xs6 style='padding-right:8px;')
            v-text-field(outlined v-model.number='resultado.goles_local' :label="'Goles ' + partidoSeleccionado.nombre_local" type='number' min='0' dense)
          v-flex(xs6)
            v-text-field(outlined v-model.number='resultado.goles_visitante' :label="'Goles ' + partidoSeleccionado.nombre_visitante" type='number' min='0' dense)
        p.grey--text(style='font-size:12px;') Al guardar se calcularán los puntos de todas las apuestas automáticamente.
      v-card-actions
        v-spacer
        v-btn(text @click='dialogRes = false') Cancelar
        v-btn(style='background:green;' dark @click='guardarResultado' :loading='guardando') Confirmar Resultado

  //- Dialog importar juegos
  v-dialog(v-model='dialogImportarJ' max-width='900px')
    v-card
      v-card-title(style='background:black;display:flex;align-items:center;justify-content:space-between;')
        span.white--text Partidos encontrados en la API ({{ partidosAPI.length }})
        v-btn(icon dark @click='dialogImportarJ=false')
          v-icon mdi-close
      v-card-text(style='padding:0;')
        div(v-if='loadingJuegosAPI' style='text-align:center;padding:40px;')
          v-progress-circular(indeterminate color='#ff6500')
          p.grey--text(style='margin-top:12px;') Cargando partidos...
        div(v-else)
          div(style='padding:10px 16px;background:#f5f5f5;display:flex;align-items:center;gap:12px;flex-wrap:wrap;')
            span(style='font-size:13px;color:#555;') {{ partidosSeleccionados.length }} seleccionados
            v-btn(small text @click='seleccionarTodosJ') Seleccionar todos
            v-btn(small text @click='partidosSeleccionados=[]') Limpiar
            v-select(
              v-model='filtroFaseImport'
              :items='[{text:"Todas las fases",value:""},{text:"Grupos",value:"group"},{text:"Octavos (R32)",value:"r32"},{text:"Octavos (R16)",value:"r16"},{text:"Cuartos",value:"qf"},{text:"Semis",value:"sf"},{text:"Tercer Puesto",value:"third"},{text:"Final",value:"final"}]'
              dense hide-details outlined
              style='max-width:200px;background:white;'
              label='Filtrar fase'
            )
          div(style='max-height:460px;overflow-y:auto;')
            v-data-table(
              :headers='headersImportJ'
              :items='partidosAPIFiltrados'
              hide-actions
              style='font-size:12px;'
            )
              template(v-slot:items='props')
                td
                  v-checkbox(
                    :input-value='partidosSeleccionados.includes(props.item.id)'
                    @change='toggleSeleccionJ(props.item.id)'
                    color='#ff6500' hide-details
                  )
                td {{ props.item.local_date }}
                td
                  div(style='display:flex;align-items:center;gap:6px;')
                    img(v-if='props.item._bandera_local' :src='props.item._bandera_local' style='height:18px;')
                    span {{ props.item._nombre_local }}
                td
                  div(style='display:flex;align-items:center;gap:6px;')
                    img(v-if='props.item._bandera_visitante' :src='props.item._bandera_visitante' style='height:18px;')
                    span {{ props.item._nombre_visitante }}
                td
                  v-chip(small dark :color="props.item._fase_color") {{ props.item._fase_label }}
                td {{ props.item.group }}
                td
                  v-chip(small dark :color="props.item.yaExiste ? 'orange' : 'green'")
                    | {{ props.item.yaExiste ? 'Ya existe' : 'Nuevo' }}
      v-card-actions(style='padding:12px 16px;')
        span(style='font-size:12px;color:#999;') Los equipos deben estar importados primero para que las banderas se resuelvan correctamente
        v-spacer
        v-btn(text @click='dialogImportarJ=false') Cancelar
        v-btn(style='background:#ff6500;' dark @click='confirmarImportarJuegos' :loading='guardandoJuegos' :disabled='partidosSeleccionados.length===0')
          | Importar {{ partidosSeleccionados.length }} partido{{ partidosSeleccionados.length !== 1 ? 's' : '' }}

  v-dialog(v-model='dialog4' persistent max-width='400px')
    v-container(style='max-width:400px;background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-layout(align-start='' justify-center='' row='' wrap='')
          v-flex(xs12)
            v-card-title.justify-center
              h4.black--text Esperando Respuesta del Servidor...
          v-flex(xs12)
            div(style='display:flex;justify-content:center;')
              img(src='../assets/waiting.gif' height='150')
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaPartidos',
  data: () => ({
    resultados: [],
    equipos: [],
    loading: false,
    dialog: false,
    dialogRes: false,
    dialog4: false,
    dialogImportarJ: false,
    editando: false,
    guardando: false,
    loadingJuegosAPI: false,
    guardandoJuegos: false,
    partidosAPI: [],
    partidosSeleccionados: [],
    filtroFaseImport: '',
    headersImportJ: [
      { text: '', sortable: false },
      { text: 'Fecha', value: 'local_date' },
      { text: 'Local', sortable: false },
      { text: 'Visitante', sortable: false },
      { text: 'Fase', sortable: false },
      { text: 'Grupo', value: 'group' },
      { text: 'Estado', sortable: false }
    ],
    form: {
      equipo_local: '', equipo_visitante: '',
      nombre_local: '', nombre_visitante: '',
      bandera_local: '', bandera_visitante: '',
      fase: 'grupos', grupo: '', fecha: '', orden: 0
    },
    defaultForm: {
      equipo_local: '', equipo_visitante: '',
      nombre_local: '', nombre_visitante: '',
      bandera_local: '', bandera_visitante: '',
      fase: 'grupos', grupo: '', fecha: '', orden: 0
    },
    resultado: { goles_local: 0, goles_visitante: 0 },
    partidoSeleccionado: {},
    faseOpts: [
      { text: 'Fase de Grupos', value: 'grupos' },
      { text: 'Octavos', value: 'octavos' },
      { text: 'Cuartos', value: 'cuartos' },
      { text: 'Semifinales', value: 'semis' },
      { text: 'Tercer Puesto', value: 'tercer_puesto' },
      { text: 'Final', value: 'final' }
    ],
    headers: [
      { text: 'Fecha', value: 'fecha' },
      { text: 'Partido', sortable: false },
      { text: 'Fase', value: 'fase' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Resultado', sortable: false },
      { text: 'Estado', value: 'estado' },
      { text: 'Acciones', sortable: false }
    ]
  }),
  computed: {
    equiposOpts () {
      return this.equipos.filter(e => e.activo)
    },
    partidosAPIFiltrados () {
      if (!this.filtroFaseImport) return this.partidosAPI
      return this.partidosAPI.filter(g => g.type === this.filtroFaseImport)
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.loading = true
      Promise.all([
        Api.get('quiniela/partidos'),
        Api.get('quiniela/equipos')
      ]).then(([resP, resE]) => {
        this.resultados = resP.data
        this.equipos = resE.data
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    onLocalChange (codigo) {
      const eq = this.equipos.find(e => e.codigo === codigo)
      if (eq) { this.form.nombre_local = eq.nombre; this.form.bandera_local = eq.bandera_url || '' }
    },
    onVisitanteChange (codigo) {
      const eq = this.equipos.find(e => e.codigo === codigo)
      if (eq) { this.form.nombre_visitante = eq.nombre; this.form.bandera_visitante = eq.bandera_url || '' }
    },
    abrirCrear () {
      this.editando = false
      this.form = Object.assign({}, this.defaultForm)
      this.dialog = true
    },
    abrirEditar (item) {
      this.editando = true
      this.form = Object.assign({}, item)
      if (item.fecha) this.form.fecha = this.$moment(item.fecha).format('YYYY-MM-DDTHH:mm')
      this.dialog = true
    },
    abrirResultado (item) {
      this.partidoSeleccionado = item
      this.resultado = { goles_local: 0, goles_visitante: 0 }
      this.dialogRes = true
    },
    guardar () {
      if (!this.form.equipo_local || !this.form.equipo_visitante || !this.form.fecha) {
        this.$swal.fire('Error', 'Equipos y fecha son obligatorios.', 'error')
        return
      }
      this.guardando = true
      const req = this.editando ? Api.put('quiniela/partidos', this.form) : Api.post('quiniela/partidos', this.form)
      req.then(() => {
        this.dialog = false
        this.guardando = false
        this.$swal.fire('Listo', this.editando ? 'Partido actualizado.' : 'Partido creado.', 'success')
        this.initialize()
      }).catch(() => {
        this.guardando = false
        this.$swal.fire('Error', 'No se pudo guardar el partido.', 'error')
      })
    },
    guardarResultado () {
      if (this.resultado.goles_local === null || this.resultado.goles_visitante === null) {
        this.$swal.fire('Error', 'Ingresa los goles de ambos equipos.', 'error')
        return
      }
      this.guardando = true
      Api.post('quiniela/partidos/resultado', {
        partido_id: this.partidoSeleccionado._id,
        resultado: this.resultado
      }).then(res => {
        this.dialogRes = false
        this.guardando = false
        this.$swal.fire('Listo', `Resultado registrado. ${res.data.apuestas_calculadas} apuestas calculadas.`, 'success')
        this.initialize()
      }).catch(() => {
        this.guardando = false
        this.$swal.fire('Error', 'No se pudo registrar el resultado.', 'error')
      })
    },
    eliminar (id) {
      this.$swal.fire({
        title: '¿Eliminar partido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          this.dialog4 = true
          Api.delete('quiniela/partidos/' + id).then(() => {
            this.dialog4 = false
            this.$swal.fire('Eliminado', 'Partido eliminado.', 'success')
            this.initialize()
          }).catch(() => {
            this.dialog4 = false
            this.$swal.fire('Error', 'No se pudo eliminar.', 'error')
          })
        }
      })
    },
    async abrirImportarJuegos () {
      this.dialogImportarJ = true
      this.loadingJuegosAPI = true
      this.partidosSeleccionados = []
      this.partidosAPI = []
      this.filtroFaseImport = ''
      try {
        const res = await Api.get('quiniela/partidos/fetch-api')
        const faseMap = { group: 'grupos', r32: 'octavos', r16: 'octavos', qf: 'cuartos', sf: 'semis', third: 'tercer_puesto', final: 'final' }
        const faseColor = { group: 'blue darken-2', r32: 'purple', r16: 'purple darken-2', qf: 'orange darken-2', sf: 'red darken-1', third: 'brown', final: 'black' }
        const faseLabel = { group: 'Grupos', r32: 'R32', r16: 'Octavos', qf: 'Cuartos', sf: 'Semis', third: '3er Puesto', final: 'Final' }
        const existentes = this.resultados.map(p => p.orden)
        this.partidosAPI = (res.data.games || []).map(g => {
          const localEq = this.equipos.find(e => e.nombre.toLowerCase() === (g.home_team_name_en || '').toLowerCase())
          const visitEq = this.equipos.find(e => e.nombre.toLowerCase() === (g.away_team_name_en || '').toLowerCase())
          return {
            ...g,
            _nombre_local: g.home_team_name_en || g.home_team_label || 'Por definir',
            _nombre_visitante: g.away_team_name_en || g.away_team_label || 'Por definir',
            _bandera_local: localEq ? localEq.bandera_url : '',
            _bandera_visitante: visitEq ? visitEq.bandera_url : '',
            _equipo_local: localEq ? localEq.codigo : '',
            _equipo_visitante: visitEq ? visitEq.codigo : '',
            _fase: faseMap[g.type] || 'grupos',
            _fase_label: faseLabel[g.type] || g.type,
            _fase_color: faseColor[g.type] || 'grey',
            yaExiste: existentes.includes(parseInt(g.id))
          }
        })
        this.partidosSeleccionados = this.partidosAPI
          .filter(g => !g.yaExiste)
          .map(g => g.id)
      } catch (e) {
        this.$swal.fire('Error', 'No se pudo conectar con la API del Mundial.', 'error')
        this.dialogImportarJ = false
      }
      this.loadingJuegosAPI = false
    },
    seleccionarTodosJ () {
      this.partidosSeleccionados = this.partidosAPIFiltrados.map(g => g.id)
    },
    toggleSeleccionJ (id) {
      const idx = this.partidosSeleccionados.indexOf(id)
      if (idx >= 0) this.partidosSeleccionados.splice(idx, 1)
      else this.partidosSeleccionados.push(id)
    },
    parseLocalDate (str) {
      // "MM/DD/YYYY HH:mm" → ISO
      const [datePart, timePart] = str.split(' ')
      const [mm, dd, yyyy] = datePart.split('/')
      return `${yyyy}-${mm}-${dd}T${timePart}:00`
    },
    async confirmarImportarJuegos () {
      const aImportar = this.partidosAPI.filter(g => this.partidosSeleccionados.includes(g.id))
      this.guardandoJuegos = true
      let ok = 0; let err = 0
      for (const g of aImportar) {
        const payload = {
          equipo_local: g._equipo_local || 'TBD',
          equipo_visitante: g._equipo_visitante || 'TBD',
          nombre_local: g._nombre_local,
          nombre_visitante: g._nombre_visitante,
          bandera_local: g._bandera_local,
          bandera_visitante: g._bandera_visitante,
          fase: g._fase,
          grupo: g.group || '',
          fecha: this.parseLocalDate(g.local_date),
          orden: parseInt(g.id)
        }
        try {
          if (g.yaExiste) {
            const p = this.resultados.find(r => r.orden === parseInt(g.id))
            if (p) await Api.put('quiniela/partidos', { ...payload, _id: p._id })
          } else {
            await Api.post('quiniela/partidos', payload)
          }
          ok++
        } catch (e) { err++ }
      }
      this.guardandoJuegos = false
      this.dialogImportarJ = false
      this.initialize()
      this.$swal.fire(
        'Importación completa',
        ok + ' partido(s) importados.' + (err > 0 ? ' ' + err + ' fallaron.' : ''),
        err > 0 ? 'warning' : 'success'
      )
    },
    faseName (f) {
      const m = { grupos: 'Grupos', octavos: 'Octavos', cuartos: 'Cuartos', semis: 'Semis', tercer_puesto: '3er Puesto', final: 'Final' }
      return m[f] || f
    },
    estadoColor (e) {
      return e === 'finalizado' ? 'green' : e === 'en_juego' ? 'orange' : 'grey'
    },
    estadoLabel (e) {
      return e === 'finalizado' ? 'Finalizado' : e === 'en_juego' ? 'En juego' : 'Pendiente'
    }
  }
}
</script>
